module.exports = __webpack_public_path__ + "static/media/ic-arrow-down-green.e373ab3d.svg";